import createErrorHandler from 'utils/createErrorHandler';

function validateScheduleClassesForm(state) {
  const [errors, addError] = createErrorHandler();

  if (state.superBatches.length === 0) {
    addError('batch_and_library', 'Select atleast one batch!');
  }

  if (!state.academySchedule) {
    addError('schedule', 'Select a schedule to proceed!');
  }

  if (!state.startDate) {
    addError('schedule', 'Select a schedule start date to proceed!');
  }

  const selectedClasses = Object.values(state.academyTopics).filter(
    (o) => o.selected
  );
  if (selectedClasses.length === 0) {
    addError('library_classes', 'Select atleast one class to proceed!');
  }

  selectedClasses.forEach((cls) => {
    if (!cls.isInstructorRequired) return;

    if (!cls.primaryInstructor) {
      addError(
        'library_classes',
        `Select primary instructor for class ${cls.order + 1}!`
      );
      return;
    }

    const primaryInstructorId = cls.primaryInstructor.value;
    const secondaryInstructorId = cls?.secondaryInstructor?.value;
    const otherInstructorIds = cls.otherInstructors.map((o) => o.value);

    if (primaryInstructorId === secondaryInstructorId) {
      addError(
        'library_classes',
        `Same primary and secondary instructors selected for class ${
          cls.order + 1
        }!`
      );
    }

    if (otherInstructorIds.includes(primaryInstructorId)) {
      addError(
        'library_classes',
        `Primary instructor is also selected as other instructor for class ${
          cls.order + 1
        }!`
      );
    }

    if (otherInstructorIds.includes(secondaryInstructorId)) {
      addError(
        'library_classes',
        `Secondary instructor is also selected as other instructor for class ${
          cls.order + 1
        }!`
      );
    }
  });

  return errors;
}

export default validateScheduleClassesForm;
